module.exports = __webpack_public_path__ + "a6ed56abb83da72636cd48dbf1213fa3.svg";